import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

export const Frame = React.memo(
  ({
    Icon,
    fillOpacity,
    fill = variables['colors-mc-text-primary'],
    width = 30,
    viewSize = 30,
    light = false,
    outline = false,
    dark = false,
    radius = false,
    circle = false,
    fillIcon,
    padding = 0,
    strokeWidthIcon = 0
  }) => {
    const viewBox = `0 0 ${viewSize} ${viewSize}`;
    const rx = radius ? '5' : circle ? '14.5' : '0';
    const svgIconPadding = (width * padding) / viewSize / 2;
    fillOpacity = fillOpacity || (dark ? '1' : '0.1');
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={remCss(width)}
        height={remCss(width)}
        viewBox={viewBox}
        fill={'none'}
      >
        {(light || dark) && (
          <rect
            width={viewSize - (outline ? 1 : 0)}
            height={viewSize - (outline ? 1 : 0)}
            fill={fill}
            rx={rx}
            fillOpacity={fillOpacity}
          />
        )}
        {!padding ? (
          <Icon fill={fillIcon || (dark ? '#fff' : fill)} strokeWidth={strokeWidthIcon} />
        ) : (
          <g transform={'translate(' + svgIconPadding + ',' + svgIconPadding + ')'}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width={viewSize - svgIconPadding * 2}
              height={viewSize - svgIconPadding * 2}
              viewBox={viewBox}
              fill={'none'}
            >
              <Icon fill={fillIcon || (dark ? '#fff' : fill)} strokeWidth={strokeWidthIcon} />
            </svg>
          </g>
        )}
        {outline && (
          <rect
            width={viewSize - 1}
            height={viewSize - 1}
            x='0.5'
            y='0.5'
            rx={rx}
            stroke={fill}
            strokeWidth={strokeWidthIcon || 1}
          />
        )}
      </svg>
    );
  }
);
Frame.displayName = 'Frame';
